import * as React from 'react';

export const AudioErrorIcon = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="audio-error-icon"
  >
    <path
      d="M9 18C9 16.8954 9.89543 16 11 16H64C66.2091 16 68 17.7909 68 20V57C68 60.3137 65.3137 63 62 63H13C10.7909 63 9 61.2091 9 59V18Z"
      className="fill-red-50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4226 11H8C5.89039 11 4.16375 12.6319 4.01091 14.7036L4.00819 14.7404L4.00684 14.7773L4.00135 14.9265L4 14.9633V15V55C4 57.1096 5.63185 58.8362 7.70358 58.9891L7.7404 58.9918L7.77729 58.9932L7.92655 58.9986L7.96326 59H8H45.1355L43.9808 57H8L7.85074 56.9945C6.81588 56.9182 6 56.0544 6 55V15L6.00549 14.8507C6.08183 13.8159 6.94564 13 8 13H18.5774L17.4226 11ZM50.909 57H60C61.0544 57 61.9182 56.1841 61.9945 55.1493L62 55V15C62 13.9456 61.1841 13.0818 60.1493 13.0055L60 13H25.5056L24.3509 11H60H60.0367L60.0735 11.0013L60.2227 11.0068L60.2596 11.0082L60.2964 11.0109C62.3681 11.1638 64 12.8904 64 15V55V55.0367L63.9986 55.0735L63.9932 55.2227L63.9918 55.2596L63.9891 55.2964C63.8362 57.3681 62.1096 59 60 59H52.0637L50.909 57Z"
      className="fill-red-600"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.1322 27.8175L23.6547 30.7631C23.4741 30.9161 23.2451 31 23.0084 31H18C17.4477 31 17 31.4478 17 32V40C17 40.5523 17.4477 41 18 41H23.0406C23.2576 41 23.4688 41.0706 23.6421 41.2012L32.3985 47.7942C33.0575 48.2904 34 47.8203 34 46.9953V39.7128L32 36.2487V44.9906L24.8451 39.6034C24.325 39.2118 23.6917 39 23.0406 39H19V33H23.0084C23.7185 33 24.4056 32.7482 24.9474 32.2892L23.6953 30.811L24.9474 32.2892L28.1485 29.5777L27.1322 27.8175ZM41.7713 41.1732L40.7105 39.3358C41.5166 38.283 42 36.952 42 35.5C42 33.0167 40.586 30.8869 38.5614 29.8987C38.0651 29.6565 37.8591 29.0577 38.1013 28.5614C38.3436 28.0651 38.9423 27.8591 39.4386 28.1014C42.1439 29.4218 44 32.2453 44 35.5C44 37.6977 43.1538 39.6987 41.7713 41.1732ZM45.0517 46.855L44.0448 45.1109C47.0955 42.7861 49 39.3274 49 35.5C49 31.0632 46.4407 27.1218 42.5032 24.8679C42.0239 24.5936 41.8578 23.9826 42.1321 23.5033C42.4065 23.0239 43.0175 22.8578 43.4968 23.1322C47.972 25.6939 51 30.2535 51 35.5C51 40.1132 48.659 44.1952 45.0517 46.855ZM34 27.7128L31.785 23.8763L32.3537 23.3946C33.0035 22.8442 34 23.306 34 24.1576V27.7128Z"
      className="fill-red-600"
    />
    <path
      d="M18 6L51 63.1577"
      className="stroke-red-600"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
